<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12YW9uc/tc-custom/9781504015554.jpg?1702846312124" alt="This image is the cover for the book Liberty and Sexuality"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Liberty and Sexuality
      </h1>
      <p class="bookDescription body article font2">
        <b>Pulitzer Prize–winning author David J. Garrow’s stirring and essential history of the politics of abortion and America’s battle for the right to choose</b><br/><br/> In 1973, the Supreme Court handed down its landmark <i>Roe v. Wade</i> decision legalizing abortion, and more than forty years later the issue continues to spark controversy and divisiveness. But behind this historic legal case lie the battles women fought to establish their rights to use contraceptives and choose to have an abortion. <i>Liberty and Sexuality</i> traces these political and legal struggles in the decades leading up to <i>Roe v. Wade</i>—including the momentous 1965 Supreme Court ruling in <i>Griswold v. Connecticut</i> that established a constitutional “right to privacy.” Garrow personalizes the struggles by detailing the vital contributions made by dozens of crusaders who tirelessly paved the way.<br/>  <br/> This expansive and substantial work also addresses the threats to sexual privacy and the legality of abortion that have risen since <i>Roe v. Wade</i>. With abortion still a contentious subject on the national political landscape, <i>Liberty and Sexuality</i> is not just a historical account of the right to choose, but an indispensable read about preserving a freedom that continues to divide America.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David J. Garrow
      </h2>
      
      <p class="authorDescription body article">David J. Garrow is a Pulitzer Prize&ndash;winning historian who is presently professor of law and history and Distinguished Faculty Scholar at the University of Pittsburgh School of Law. Garrow, who earned his PhD from Duke University, is an acclaimed scholar of the United States&rsquo; black freedom struggle and reproductive rights movement, as well as of the US Supreme Court. His definitive biography of Martin Luther King Jr., <I>Bearing the Cross: Martin Luther King, Jr., and the Southern Christian Leadership Conference</I>, was honored with the 1987 Pulitzer Prize for biography and the seventh-annual Robert F. Kennedy Book Award.<BR /><BR /> Garrow&rsquo;s other books are <I>Protest at Selma: Martin Luther King, Jr., and the Voting Rights Act of 1965</I>, <I>The FBI and Martin Luther King, Jr.: From &ldquo;Solo&rdquo; to Memphis</I>, and <I>Liberty and Sexuality: The Right to Privacy and the Making of Roe v. Wade</I>. He also served as a senior adviser to <I>Eyes on the Prize</I>, the award-winning PBS documentary series on the civil rights movement.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?585a8800